<template>
  <v-dialog v-model="isVisibleState" :max-width="maxWidth" :fullscreen="$vuetify.breakpoint.mobile">
    <v-card class="position-relative">
      <v-btn absolute plain icon top right @click="isVisibleState = false">
        <v-icon v-text="'mdi-close'"></v-icon>
      </v-btn>
      <v-card-title>
        <app-title v-if="title" size="normal" weight="bold">{{ title }}</app-title>
      </v-card-title>
      <v-card-text>
        <iframe v-if="src" :title="title" :src="src" width="100%" :height="height"></iframe>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AppIframeDialog',
  props: {
    isVisible: {
      required: true,
      type: Boolean,
      default: false,
    },

    name: {
      required: true,
      type: String,
      default: '',
    },

    src: {
      required: false,
      type: String,
      default: '',
    },

    maxWidth: {
      required: false,
      type: Number,
      default: 900,
    },

    height: {
      required: false,
      type: Number,
      default: 500,
    },

    title: {
      required: false,
      type: String,
      default: '',
    },
  },

  data() {
    return {};
  },

  computed: {
    isVisibleState: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.toggleVisible(value);
      },
    },
  },

  watch: {
    isVisible(value) {
      if (!value) this.$emit('close');
    },
  },

  methods: {
    toggleVisible(state) {
      this.$emit('toggle-visible', {name: this.name, state});
    },
  },
};
</script>
